
import { BrowserRouter } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import {
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'


import Toast from './components/base/Toast';
import routes from './router/config';
import BottomNav from './components/feature/BottomNav';
import MobileRedirect from './components/feature/MobileRedirect';
import { BackButtonHandler } from './components/feature/BackButtonHandler';

function AppRoutes() {
  const element = useRoutes(routes);
  return element;
}


const queryClient = new QueryClient()

function AppContent() {
  return (
    <div className="min-h-screen bg-gray-50">
      <MobileRedirect />
      <BackButtonHandler />
      {/* Desktop Layout with Sidebar */}
      <div className="block md:flex min-h-screen">

        {/* Main Content */}
        <div className="flex-1 flex flex-col min-h-screen lg:ml-0">
          {/* Page Content */}
          <main className="flex-1 pb-20 lg:pb-4">
            <div className="min-h-full">
              <AppRoutes />
            </div>
          </main>

          {/* Bottom Navigation - Mobile Only */}
          <div className="lg:hidden flex-shrink-0">
            <BottomNav />
          </div>
        </div>
      </div>

      <Toast />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <QueryClientProvider client={queryClient}>

        <AppContent />
      </QueryClientProvider>

    </BrowserRouter>
  );
}

export default App;
